// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".header[data-v-2b1f1403]{background:linear-gradient(#61c7f7,#009ce5)}.circle[data-v-2b1f1403]{height:36px;width:36px;line-height:36px;background:#fff;border-radius:50%}#routeByTrainBusContents[data-v-2b1f1403]::-webkit-scrollbar{display:none}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
